


































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import ZipUtil from "@/script/zipUtil";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Toast from "@/script/message";
import Version from "@/script/version";
import store from "@/store";
import {eGameStage} from "@/common/enumData";

@Component({
    components: {ClipLoader},
})
export default class AddVersion extends Vue {
    projectId = this.$route.params.id;
    toast = new Toast();
    limitSize: number = 1024 * 1000 * 500;
    totalSize: number = 0;
    uploadGameFile: File | null = null;
    uploadGameFiles: File[] = [];
    isAdvancedOpen: boolean = false;
    startFile: string = '';
    startFileOptions: string[] = [];

    fileName: string = '';
    versionDescription: string = "";

    isLoadingFile: boolean = false;
    autoDeploy: boolean = true;

    version: string = '1.0.1';
    isUpdate: boolean = false;
    description: string = '';

    isLoadingUpload: boolean = false;

    // beforeRouteEnter(to, from, next){
    //
    //     if(eGameStage.Dev === (from.params.id && store.getters.projects[from.params.id].stage)){
    //         alert('개발 단계를 얼리억세스 이상으로 설정하여, 게임 파일을 업로드해주세요')
    //     }else if(!from.params.id){
    //         next('/projectList')
    //     }
    //     else{
    //         next();
    //     }
    //
    // }


    async mounted() {
        await this.$store.dispatch("loginState");
        await this.$store.dispatch("project", this.projectId);

        const lastVersion = this.$store.getters.lastVersion(this.projectId);

        if (lastVersion) {
            const ver = new Version(lastVersion.version)
            ver.patch++;
            this.version = ver.toString();
        }

        const updateVersion = this.$store.getters.updateVersion(this.projectId);
        this.isUpdate = updateVersion && updateVersion.state === 'process';


    }

    async onFileChange(e) {

        this.uploadGameFile = e.target.files[0];

        this.isLoadingFile = true;
        const zip = await ZipUtil.zipFileToZip(this.uploadGameFile);

        const files: any = await ZipUtil.zipToFiles(zip);
        let size: number = 0;

        for (let f in files) {
            size += files[f].size;
        }

        if (size > this.limitSize) {
            alert(`${this.$t('file.upload.overSize.500')}`)
            return;

        }

        this.totalSize = Number((size / (1024 * 1000)).toFixed(2));
        this.uploadGameFiles = files;

        const htmls = this.uploadGameFiles.filter((file) => {
            return file.name.indexOf('.html') > -1;
        });

        this.startFileOptions = htmls.map(file => file.name);
        this.startFileOptions.sort((a, b) => a.length - b.length);
        const indexFiles = this.startFileOptions.filter(name => name.includes('index'));

        if (indexFiles.length) {
            indexFiles.sort((a, b) => a.length - b.length);
            this.startFile = indexFiles[0];
        }
        else {
            this.startFile = this.startFileOptions[0];
        }

        this.startFileOptions.sort((a, b) => a.length - b.length);

        if (this.startFileOptions.length) {
            // this.uploadGameFileError = '';
            this.fileName = e.target.files[0].name
        }
        else {
            alert(`${this.$t('notFoundHtml')}`)
            this.fileName = ''
            // this.uploadGameFileError = this.$t('projectAddVersion.error.notFoundHtml').toString();

        }

        if (
            this.uploadGameFiles.length > 0 &&
            this.startFileOptions.length > 0
        ) {
            this.$store.commit("sendGameFileDone", true);

            const gameFileInfo = {
                autoDeploy: this.autoDeploy,
                startFile: this.startFile,
                size: this.totalSize,
                version_description: this.versionDescription,
            };
            console.log('gameFileInfo', gameFileInfo);
            this.$store.commit("gameFileInfoObj", gameFileInfo);
            this.$store.commit("uploadGameFiles", this.uploadGameFiles);
        }
        else {
            this.$store.commit("sendGameFileDone", false);
        }

        this.isLoadingFile = false;
    }

    deleteFile() {
        this.uploadGameFile = null;
        this.uploadGameFiles = [];
        this.startFile = '';
        this.startFileOptions = [];
        this.totalSize = 0;
        this.fileName = '';
        (this.$refs.gameFile as any).value = '';
    }

    async upload() {
        if (this.isLoadingUpload) {
            return;
        }

        let isError = false;

        if (!Version.validity(this.version)) {
            isError = true;
            console.log('version error')
            // this.versionError = this.$t('projectAddVersion.error.notValidVersion').toString();
        }
        else {

            const lastVersion = this.$store.getters.lastVersion(this.projectId);

            if (lastVersion && Version.validity(lastVersion.version)) {
                const newVersion = new Version(this.version);
                const oldVersion = new Version(lastVersion.version);

                if (!newVersion.isNew(oldVersion)) {
                    //이전 버전 보다 작음.
                    isError = true;
                    // this.versionError = this.$t('projectAddVersion.error.lowVersion').toString();
                    return;
                }
            }
        }


        if (!this.uploadGameFiles.length) {
            isError = true;
            // this.uploadGameFileError = this.$t('projectAddVersion.error.noUploadFile').toString();
        }

        if (!this.startFileOptions.length) {
            isError = true;
        }

        if (isError) {
            // this.wait = false;
            return;
        }

        if (this.$store.getters.gameStage === eGameStage.Dev) {
            this.autoDeploy = false;
        }
        this.isLoadingUpload = true;
        const version = await this.$api.createVersion(this.projectId, this.version, this.uploadGameFiles, this.startFile,
            this.autoDeploy, this.totalSize, this.description, this.$store.getters.gameStage);

        if (!version || version.error) {
            // Notify.create({
            //     message : this.$t('projectAddVersion.error.newVersionUploadFail').toString(),
            //     position : 'top',
            //     color : 'negative',
            //     timeout: 2000
            // });
        }
        else {
            this.isLoadingUpload = false;
            const project = this.$store.getters.project(this.projectId);
            project.update_version_id = version.id;
            project.projectVersions.push(version);

            console.log(project)
            project.versions ? project.versions[version.id] = version : this.$store.commit('versions', project.projectVersions);
            ;

            // Notify.create({
            //     message : this.$t('projectAddVersion.success.uploadFile').toString(),
            //     position : 'top',
            //     color : 'primary',
            //     timeout: 2000
            // });
            await this.$router.replace(`/${this.$i18n.locale}/projectList`);
        }


    }

    updateProject() {

    }

    prevPage() {
        this.$emit('gameInfoDone', false)
    }

}
